import { Pipe, PipeTransform } from '@angular/core';
import { migrateQuillContent } from '../constants/froala-editor-config.constant';

@Pipe({
  name: 'migrateQuill',
  pure: true,
  standalone: false
})
export class MigrateQuillPipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    return migrateQuillContent(value ?? '');
  }
}
